import { Theme } from "constants/enums";
import { useTheme } from "services/ThemeContext";
import sign from "shared/images/zeiton-sign.svg";
import wordmark from "shared/images/zeiton-wordmark.svg";
import wordmarkOnDark from "shared/images/zeiton-wordmark-on-dark.svg";
import styles from "./ZeitonLogo.module.scss";

/**
 * `horizontal` is the name centred with the sign to its left, at a fixed size; `wordmark` the name
 * alone and `sign` the mark alone, both sized by the caller.
 */
export type ZeitonLogoVariant = "horizontal" | "wordmark" | "sign";

// The name is dark navy on the light theme and white on the dark one; the sign is the same on both.
const NAME: Record<Theme, string> = { [Theme.light]: wordmark, [Theme.dark]: wordmarkOnDark };

interface ZeitonLogoProps {
    variant: ZeitonLogoVariant;
    className?: string;
}

/** The ZEITON logo in the version that reads on the current theme. */
export function ZeitonLogo({ variant, className }: ZeitonLogoProps) {
    const { theme } = useTheme();

    if (variant === "sign") {
        return <img className={className} src={sign} alt="ZEITON" />;
    }
    if (variant === "wordmark") {
        return <img className={className} src={NAME[theme]} alt="ZEITON" />;
    }
    return (
        <span className={[styles.horizontal, className].filter(Boolean).join(" ")}>
            <img className={styles.sign} src={sign} alt="" />
            <img className={styles.name} src={NAME[theme]} alt="ZEITON" />
        </span>
    );
}
